"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[287],{

/***/ 33890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ compositions_InfinityScrollProductFeed_InfinityScrollProductFeed)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(73095);
// EXTERNAL MODULE: ./src/components/feedback/NoData/NoData.tsx + 1 modules
var NoData = __webpack_require__(17755);
;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/components/NoItems/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "We couldn't find any results for the above selections.<br />Please remove some options, or try again."
    }
});

;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/components/NoItems/NoItems.tsx




const NoItems = (param)=>{
    let { className } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {
        className: className,
        title: messages.title
    });
};
/* harmony default export */ const NoItems_NoItems = (NoItems);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDetailed/ProductCardDetailed.tsx
var ProductCardDetailed = __webpack_require__(55493);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(80759);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDrift/ProductCardDrift.tsx + 2 modules
var ProductCardDrift = __webpack_require__(84313);
;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/util/index.ts
// helper to fix types
function isProduct(object) {
    return object && object.__typename === "Product";
}

;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/components/ProductList/ProductList.tsx









const ProductList = (props)=>{
    const { className, products, metadata, isEcommerce, withEcommercePrefix, excludeLabels, withoutNotes, withForwardedTradingItemId = false } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    if (!products?.length) {
        return null;
    }
    const isSingleProductWithVariety = isMobile && products.length === 1 && isProduct(products[0]) && products[0].hasVariety;
    const rootClassName = isSingleProductWithVariety ? "mt-16" : (0,clsx/* default */.Z)(className, "grid items-stretch gap-16", isMobile ? "grid-cols-2-center" : "grid-cols-3-center");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
        className: rootClassName,
        children: products.map((data)=>{
            if (isProduct(data)) {
                const productProps = {
                    key: data.id,
                    data,
                    isEcommerce,
                    withEcommercePrefix,
                    excludeLabels,
                    withDescription: false,
                    buttonProps: {
                        metadata
                    },
                    withoutNotes,
                    withForwardedTradingItemId
                };
                let ProductCardComponent = ProductCardDetailed/* default */.Z;
                if (data.hasVariety) {
                    ProductCardComponent = ProductCardDrift/* default */.Z;
                } else if (isMobile) {
                    ProductCardComponent = ProductCardSmall/* default */.Z;
                }
                return /*#__PURE__*/ react.createElement(ProductCardComponent, productProps);
            }
            return data;
        })
    });
};
/* harmony default export */ const ProductList_ProductList = (ProductList);

// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntryListener.ts + 1 modules
var useEntryListener = __webpack_require__(36191);
;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/components/FetchMoreIndicator/FetchMoreIndicator.tsx



const FetchMoreIndicator = (param)=>{
    let { fetchMore } = param;
    const [ref] = (0,useEntryListener/* default */.Z)((entry)=>{
        if (entry.isIntersecting) {
            fetchMore();
        }
    }, {
        once: true,
        observerProps: {
            rootMargin: "100%"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref
    });
};
/* harmony default export */ const FetchMoreIndicator_FetchMoreIndicator = (FetchMoreIndicator);

;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/components/InfinityScrollProductFeedMobileView/InfinityScrollProductFeedMobileView.tsx









const InfinityScrollProductFeed = (props)=>{
    const { className, products, metadata, fetchMore, totalCount, fetchSkeletonsAmount, injectBanners, isEcommerce, isFetching, excludeLabels, withoutNotes, withEcommercePrefix } = props;
    /*
  * |c| — common product card
  * |v| — product card with variety
  * |b| — injected banner
  *
  * Injected banner:
  * Index — 6
  *
  * Input:      Output:
  * |c| |c|     |c| |c|
  * |c| |c|  => |c| |c|
  * |c| |v|     |—————|
  * |c| |c|     |  v  |
  *             |—————|
  *             |c| |c|
  *             |  b  |
  *               |c|
  * */ const content = (0,react.useMemo)(()=>{
        if (!products) {
            return [];
        }
        const productListCommonProps = {
            metadata,
            excludeLabels,
            isEcommerce,
            withEcommercePrefix,
            withoutNotes
        };
        // All nodes that will be rendered in the feed
        const feedNodes = [];
        // Temporary storage of accumulated products without variety
        let productChunk = [];
        let indexForBanners = 0;
        const renderProductList = (key, productList)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductList, {
                className: feedNodes.length ? "mt-16" : null,
                products: productList,
                ...productListCommonProps
            }, key);
        };
        const processProductChunk = function(index) {
            let finalChunk = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            // don't flush empty chunk or not-final junk with one element
            if (!products.length || !finalChunk && products.length === 1) {
                return;
            }
            // If this is not the final chunk and there's an odd number of products,
            // remove the last product and place it in the next group
            const lastProduct = !finalChunk && productChunk.length % 2 === 1 ? productChunk.pop() : null;
            feedNodes.push(renderProductList(`products-${index}`, productChunk));
            productChunk = lastProduct ? [
                lastProduct
            ] : [];
        };
        products.forEach((product, index)=>{
            // If current product has a variety, we add all the accumulated products to the feed nodes,
            // and then add a variety product card to the feed nodes as well
            if (isProduct(product) && product.hasVariety) {
                processProductChunk(index);
                feedNodes.push(renderProductList(`products-with-variety-${index}`, [
                    product
                ]));
                return;
            }
            // Banner should consider only products without variety, so we count indexes for it separately
            const injectedBanner = injectBanners?.find((banner)=>banner.index === indexForBanners);
            indexForBanners++;
            if (injectedBanner) {
                processProductChunk(index);
                feedNodes.push(injectedBanner.node);
            }
            // After adding banners and cards for variety products, as well as (possibly) accumulated products, we can add the current product to the chunk
            productChunk.push(product);
            // If we have reached the end of the product list, we need to add all the remaining products
            // to the end of the feed, regardless of their quantity
            if (index === products.length - 1) {
                processProductChunk(index, true);
            }
        });
        return feedNodes;
    }, [
        products,
        metadata,
        excludeLabels,
        isEcommerce,
        withEcommercePrefix,
        withoutNotes,
        injectBanners
    ]);
    if (!isFetching && products && !products?.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItems_NoItems, {
            className: "mt-48"
        });
    }
    const currentCount = products?.length || 0;
    const isFetchMoreVisible = !isFetching && totalCount > currentCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: content
            }),
            isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                className: "grid-cols-2-center mt-16 grid items-stretch gap-16",
                children: Array(fetchSkeletonsAmount || 6).fill(0).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmallSkeleton/* default */.Z, {}, index))
            }),
            isFetchMoreVisible && // key required for remount after product list update
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FetchMoreIndicator_FetchMoreIndicator, {
                fetchMore: fetchMore
            }, currentCount)
        ]
    });
};
/* harmony default export */ const InfinityScrollProductFeedMobileView = (/*#__PURE__*/react.memo(InfinityScrollProductFeed));

// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDetailedSkeleton/ProductCardDetailedSkeleton.tsx
var ProductCardDetailedSkeleton = __webpack_require__(1511);
;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/components/InfinityScrollProductFeedDesktopView/InfinityScrollProductFeedDesktopView.tsx








const InfinityScrollProductFeedDesktopView = (props)=>{
    const { className, products, metadata, fetchMore, totalCount, fetchSkeletonsAmount, injectBanners, isEcommerce, isFetching, excludeLabels, withoutNotes, withEcommercePrefix, withForwardedTradingItemId = false } = props;
    if (!isFetching && products && !products?.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItems_NoItems, {
            className: "mt-96"
        });
    }
    const productListCommonProps = {
        metadata,
        excludeLabels,
        isEcommerce,
        withEcommercePrefix,
        withoutNotes,
        withForwardedTradingItemId
    };
    let content;
    if (injectBanners && products?.length) {
        let lastIndex = 0;
        injectBanners.forEach((banner)=>{
            // we're expecting that we don't ruin the UI and don't put banners before all products,
            // at this moment all positions starts from 6
            const { node, index } = banner;
            content = content || [];
            content.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductList, {
                className: lastIndex ? "mt-16" : null,
                products: products.slice(lastIndex, index),
                ...productListCommonProps
            }, `products-${index}`));
            content.push(node);
            lastIndex = index;
        });
        // extract last portion of products after all banners
        if (lastIndex > 0 && products.length > lastIndex) {
            content.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductList, {
                className: "mt-16",
                products: products.slice(lastIndex),
                ...productListCommonProps
            }, "products-last"));
        }
    } else {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductList, {
            products: products,
            ...productListCommonProps
        });
    }
    const currentCount = products?.length || 0;
    const isFetchMoreVisible = !isFetching && totalCount > currentCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: content
            }),
            isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                className: "grid-cols-3-center mt-16 grid items-stretch gap-16",
                children: Array(fetchSkeletonsAmount || 6).fill(0).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardDetailedSkeleton/* default */.Z, {}, index))
            }),
            isFetchMoreVisible && // key required for remount after product list update
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FetchMoreIndicator_FetchMoreIndicator, {
                fetchMore: fetchMore
            }, currentCount)
        ]
    });
};
/* harmony default export */ const InfinityScrollProductFeedDesktopView_InfinityScrollProductFeedDesktopView = (/*#__PURE__*/react.memo(InfinityScrollProductFeedDesktopView));

;// CONCATENATED MODULE: ./src/compositions/InfinityScrollProductFeed/InfinityScrollProductFeed.tsx





const InfinityScrollProductFeed_InfinityScrollProductFeed = (props)=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const ViewComponent = isMobile ? InfinityScrollProductFeedMobileView : InfinityScrollProductFeedDesktopView_InfinityScrollProductFeedDesktopView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewComponent, {
        ...props
    });
};
/* harmony default export */ const compositions_InfinityScrollProductFeed_InfinityScrollProductFeed = (/*#__PURE__*/react.memo(InfinityScrollProductFeed_InfinityScrollProductFeed));


/***/ })

}]);